<ng-container [formGroup]="filesForm">
  <button
    *ngIf="filesForm.controls.files.valid; else errorMultipleButton"
    type="button"
    matTooltip="La taille maximale pour un produit est de 100Mo, ou 1 Go pour les abonnés Premium. Nommez correctement vos fichiers avant de les téléverser (ex : Grille-observation plutôt que test-10482)"
    mat-button
    color="primary"
    (click)="filesInput.click()"
  >
    {{ filesLabel }}
  </button>
  <ng-template #errorMultipleButton>
    <button
      type="button"
      matTooltip="La taille maximale pour un produit est de 100Mo, ou 1 Go pour les abonnés Premium. Nommez correctement vos fichiers avant de les téléverser (ex : Grille-observation plutôt que test-10482)"
      mat-button
      color="warn"
      (click)="filesInput.click()"
    >
      {{ filesLabel }}
    </button>
  </ng-template>
  <input
    hidden
    data-test="addFilesInput"
    type="file"
    formControlName="files"
    multiple="multiple"
    accept="*/*"
    #filesInput
  />
  <br />
  <mat-list dense>
    <div mat-subheader>Fichiers du produit:</div>
    <mat-list-item *ngFor="let filename of fileNames">
      <mat-icon color="primary" mat-list-icon>insert_drive_file</mat-icon>
      {{ filename }}
      <button type="button" (click)="delete(filename)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item *ngIf="!fileNames || fileNames?.length === 0"
    >Aucun Fichiers
    </mat-list-item
    >
  </mat-list>
  <br/>
  <mat-error *ngIf="filesForm.controls.files.invalid"
  >{{ filesErrorLabel }}
  </mat-error>
</ng-container>
